import { render } from "./LoadingIcon.vue?vue&type=template&id=57b07045&scoped=true"
const script = {}

import "./LoadingIcon.vue?vue&type=style&index=0&id=57b07045&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b07045"]])

export default __exports__